module.exports = __webpack_public_path__ + "static/media/ic_small_save.6a4e18b1.svg";